<template>
  <div class="bg-[#23242A] text-white app-header custom" id="content_screen">
    <div v-if="vg_selectedLocation.id" :class="'p-3 pb-[160px] flex content-main ' + (action.component ? ' half-it gap-5' : 'gap-5')">
      <div class="custom-full custom-left">
        <div class="bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px] mb-[80px]">
          <!-- <div class="flex justify-between mb-5 h-[40px]">
            <mdicon @click="addUpdate({ component: 'Add', data: {}})" v-if="!action.component" size="32" name="plus" class="text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"/>
          </div> -->
          <template v-if="vg_selectedLocation.id">
            <List :selectedCallback="selectedItem" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/>
          </template>
          <p v-else class="text-center text-theme-red">Please select a location from the top left corner.</p>

        </div>
      </div>
  
      <div :class="'w-full hidden-component custom-right'" v-if="action.component" >
        <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
      </div>

    </div>



    <div class="flex lg:flex-row flex-col bg-[#2B2C32] rounded-xl" v-else>
          
        <div class="w-full">
          <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]">
            <p  class="text-center text-theme-red">Please select a location from the top left corner.</p>
          </div>
        </div>
      
    </div>

  
  </div>
</template>




<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import List from '@/views/CashMgmt/EndOfDay/List.vue';
import Update from '@/views/CashMgmt/EndOfDay/Update.vue';
import router from '@/router';


export default defineComponent({
  name: "EodReports",
  components: {
    List,
    Update,
  },

  setup() {
    const action:any = ref({
      component: '',
      data: {},
    });
    return {
      action,
    };
  },

   watch: {
    'vg_selectedLocation'(val) {
      if(this.vg_userToken){
        this.clearComponent();
      }else{
        router.push('/login?sessionExpired=1')
      }
    },
  },

  computed: {
    ...mapGetters({
     vg_userToken: 'auth/userToken',
     vg_selectedLocation: 'location/selected'
    }),
  },

  mounted() {
    this.emitter.on("reset-eod-component", data => {
      this.clearComponent();
    });
  },

  beforeDestroy() {
    this.emitter.off('reset-eod-component', () => {});
    this.emitter.off('refresh-eod-list', () => {});
  },
 
  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
      }
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>